import { render } from "./EdoDocumentAdditionalTitleCard.vue?vue&type=template&id=561c045c"
import script from "./EdoDocumentAdditionalTitleCard.vue?vue&type=script&lang=js"
export * from "./EdoDocumentAdditionalTitleCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__